import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { enableProdMode } from '@angular/core';
import { tokenInterceptor } from './app/interceptors/token.interceptor';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { environment } from './environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  home, homeOutline, person, personOutline, mail, mailOutline, radioButtonOff, radioButtonOn, checkmarkCircle, checkmarkCircleOutline, personCircleOutline,
  lockClosed, lockClosedOutline, airplane, airplaneOutline, bedOutline, syncOutline, calendarOutline, closeOutline, swapVerticalOutline, helpCircleOutline,
  locateOutline, locationOutline, accessibilityOutline, chevronBackOutline, chevronForwardOutline, chatboxEllipsesOutline, briefcaseOutline, calendarClearOutline, documentTextOutline,
  flashOffOutline, searchOutline, pinOutline, cashOutline, informationCircleOutline,
  timeOutline, peopleOutline,
  flashOutline, barcodeOutline,
  trailSignOutline, listOutline,
  callOutline, businessOutline,
  chatbubblesOutline,
  documentOutline,
  closeCircleOutline,
  checkmarkDoneCircleOutline,
  checkmarkDoneOutline,
  hourglassOutline, 
  albumsOutline,
  swapHorizontalOutline,
  pricetagOutline,
  logoWhatsapp,
  cardOutline, optionsOutline,
  idCardOutline, arrowBackOutline, arrowForwardOutline, chevronDownOutline,
  globeOutline, mapOutline, ticketOutline,
  keyOutline, archiveOutline, calculatorOutline, add, trash,
  helpOutline, calendarNumberOutline,
  folderOpenOutline, shieldCheckmarkOutline,
  atOutline
} from 'ionicons/icons';
import { map } from 'rxjs';
registerLocaleData(localeEs, 'es');
bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([tokenInterceptor])
    ),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    { provide: LOCALE_ID, useValue: 'es' },
  ],
});

if (environment.production) {
  enableProdMode();
  window.console.log = () => { };
}
addIcons({
  'radio-button-off': radioButtonOff, bedOutline, personCircleOutline, helpCircleOutline, archiveOutline, businessOutline, atOutline,
  'radio-button-on': radioButtonOn, swapVerticalOutline, documentTextOutline, mapOutline, peopleOutline, informationCircleOutline,
  'checkmark-circle': checkmarkCircle, briefcaseOutline, flashOffOutline, timeOutline, barcodeOutline, pinOutline, cashOutline,
  home, homeOutline, locateOutline, locationOutline, calendarOutline, callOutline, swapHorizontalOutline,
  person, personOutline, syncOutline, chevronBackOutline, chevronForwardOutline, flashOutline, chatbubblesOutline, pricetagOutline,
  mail, mailOutline, chatboxEllipsesOutline, closeOutline, trailSignOutline, checkmarkDoneOutline, cardOutline, idCardOutline, arrowBackOutline, arrowForwardOutline, chevronDownOutline,
  lockClosed, lockClosedOutline, calendarClearOutline, documentOutline, closeCircleOutline, logoWhatsapp, optionsOutline, searchOutline, helpOutline,
  'folder-open-outline': folderOpenOutline, shieldCheckmarkOutline, calendarNumberOutline, listOutline, 
  airplane, airplaneOutline, accessibilityOutline, checkmarkCircleOutline, hourglassOutline, albumsOutline, globeOutline, keyOutline, calculatorOutline, ticketOutline, add, trash
});